<template>
  <footer class="site-footer">
    <div class="footer-main">
      <div class="site-container footer-inner">
        <div class="footer-cols">
        <div class="footer-col wide">
          <h4>新西兰项目</h4>
          <div class="col-grid">
            <ul>
              <li v-for="item in projectColumns[0]" :key="item.id">
                <router-link :to="projectLink(item)">{{ item.name }}</router-link>
              </li>
            </ul>
            <ul>
              <li v-for="item in projectColumns[1]" :key="item.id">
                <router-link :to="projectLink(item)">{{ item.name }}</router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer-col">
          <h4>源盛优势</h4>
          <ul>
            <li><router-link to="/about">公司介绍</router-link></li>
            <li><router-link to="/about?tab=honor">荣誉资质</router-link></li>
            <li><router-link to="/contact">联系我们</router-link></li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>移民动态</h4>
          <ul>
            <li><router-link to="/news">商业项目</router-link></li>
            <li><router-link to="/news">资讯中心</router-link></li>
            <li><router-link to="/news">成功案例</router-link></li>
          </ul>
        </div>
        <div class="footer-col">
          <h4>相关链接</h4>
          <ul>
            <li><a href="https://www.immigration.govt.nz/" target="_blank" rel="noopener noreferrer">新西兰移民局</a></li>
            <li><a href="https://www.newzealand.com/cn/" target="_blank" rel="noopener noreferrer">新西兰旅游局</a></li>
            <li><a href="https://www.studywithnewzealand.govt.nz/cn" target="_blank" rel="noopener noreferrer">学在新西兰</a></li>
            <li><a href="https://www.mpi.govt.nz/bring-send-to-nz/bringing-and-posting-items-to-nz/check-if-you-can-bring-or-send-an-item-to-nz" target="_blank" rel="noopener noreferrer">入境新西兰申报携带物</a></li>
            <li><a href="https://www.chinaielts.org/" target="_blank" rel="noopener noreferrer">雅思考试</a></li>
          </ul>
        </div>
      </div>

      <div class="footer-contact">
        <div class="phone-block">
          <img src="@/assets/imgs/ysgj_018@2x.png" alt="电话" class="phone-icon">
          <span class="phone">{{ settings.phone }}</span>
        </div>
        <div class="qr-wrap">
          <div class="qr-item">
            <div class="qr-box">
              <img :src="settings.footer.qrSubscribe" alt="订阅号">
            </div>
            <p>源盛国际订阅号</p>
          </div>
          <div class="qr-item">
            <div class="qr-box">
              <img :src="settings.footer.qrService" alt="服务号">
            </div>
            <p>源盛国际服务号</p>
          </div>
        </div>
      </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="site-container bottom-inner">
        <div class="bottom-left">
          <p>{{ settings.footer.address }}</p>
          <p>{{ settings.footer.copyright }}</p>
        </div>
        <div class="bottom-center">
          <p>版权所有：{{ settings.footer.companyName }}</p>
          <p>{{ settings.footer.icp }} 公安联网备案号: {{ settings.footer.beian }}</p>
        </div>
        <div class="bottom-logo">
          <img src="@/assets/imgs/ysgj_017@2x.png" alt="源盛国际">
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { getProjectList, getSettingsData } from '@/api'
import { buildProjectDetailPath } from '@/data/siteData'

export default {
  name: 'SiteFooter',
  data() {
    return {
      projects: [],
      settings: {
        phone: '021-62897767',
        footer: {
          address: '上海总部: 021-62897767 长宁区江苏路369号兆丰世贸大厦1708室',
          copyright: '©2025 www.uwino.com',
          companyName: '上海专诚因私出入境服务有限公司',
          icp: '沪ICP备2023008221号',
          beian: '31010602003976',
          qrSubscribe: '',
          qrService: '',
        },
      },
    }
  },
  created() {
    this.fetchFooterData()
  },
  computed: {
    projectColumns() {
      const items = this.projects
      return [items.slice(0, 6), items.slice(6)]
    },
  },
  methods: {
    projectLink(item) {
      return buildProjectDetailPath(item.id)
    },
    async fetchFooterData() {
      try {
        const [settings, projects] = await Promise.all([
          getSettingsData(),
          getProjectList(),
        ])
        this.settings = settings || this.settings
        this.projects = Array.isArray(projects?.list) ? projects.list : []
      } catch (error) {
        this.projects = []
      }
    },
  },
}
</script>

<style scoped>
.site-footer {
  min-width: 1240px;
  background: #1659a8;
  color: rgba(255, 255, 255, 0.78);
}

.footer-main {
  padding: 34px 0 20px;
}

.footer-inner {
  display: grid;
  grid-template-columns: 1fr 240px;
  gap: 24px;
}

.footer-cols {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 24px;
}

.col-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.footer-col h4 {
  font-size: 14px;
  color: #fff;
  margin-bottom: 14px;
  font-weight: 700;
}

.footer-col li {
  font-size: 12px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.76);
}

.footer-col li a {
  color: rgba(255, 255, 255, 0.76);
  transition: color 0.2s;
}

.footer-col li a:hover {
  color: #fff;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
}

.phone-block {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  margin-bottom: 18px;
}

.phone-block .phone-icon {
  width: 24px;
  height: 24px;
  opacity: 0.9;
}

.phone-block .phone {
  font-size: 30px;
  line-height: 1;
  font-weight: 700;
  white-space: nowrap;
}

.qr-wrap {
  display: flex;
  gap: 10px;
}

.qr-item {
  text-align: center;
}

.qr-box {
  width: 72px;
  height: 72px;
  border-radius: 4px;
  background: #fff;
  border: 1px solid #8ab0dc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 7px;
  overflow: hidden;
}

.qr-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.qr-item p {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.74);
  line-height: 1.2;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  padding: 14px 0 16px;
}

.bottom-inner {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 16px;
  align-items: end;
}

.bottom-inner p {
  color: rgba(255, 255, 255, 0.62);
  font-size: 11px;
  line-height: 1.8;
}

.bottom-center {
  text-align: center;
}

.bottom-logo {
  text-align: right;
}

.bottom-logo img {
  height: 46px;
  width: auto;
}
</style>
